import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Sparkles, MessageSquare, FolderTree, Home, Settings, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const ITEMS = [
  { to: "/admin", icon: LayoutDashboard, label: "Gösterge Paneli", end: true },
  { to: "/admin/products", icon: Package, label: "Ürünler" },
  { to: "/admin/categories", icon: FolderTree, label: "Kategoriler" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Siparişler" },
  { to: "/admin/custom-orders", icon: Sparkles, label: "Özel Talepler" },
  { to: "/admin/messages", icon: MessageSquare, label: "Mesajlar" },
  { to: "/admin/homepage", icon: Home, label: "Anasayfa İçeriği" },
  { to: "/admin/settings", icon: Settings, label: "Site Ayarları" },
];

export default function AdminLayout() {
  const { user, logout, checking } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!checking && !user) navigate("/admin/login", { replace: true });
  }, [checking, user, navigate]);

  if (checking) return <div className="min-h-screen flex items-center justify-center text-larc-muted">Yükleniyor…</div>;
  if (!user) return null;

  const handleLogout = () => { logout(); navigate("/admin/login", { replace: true }); };

  return (
    <div className="flex h-screen bg-larc-admin overflow-hidden" data-testid="admin-layout">
      <aside className="w-64 bg-white border-r border-larc-border flex-shrink-0 flex flex-col">
        <Link to="/admin" className="flex items-center gap-3 px-6 h-20 border-b border-larc-border">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-larc-gold/40">
            <span className="block h-3 w-3 rounded-full bg-larc-gold" />
          </span>
          <div className="leading-none">
            <div className="font-heading text-2xl italic">Larcraft</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-larc-muted mt-0.5">admin atelier</div>
          </div>
        </Link>
        <nav className="flex-1 overflow-y-auto px-4 py-6 space-y-1">
          {ITEMS.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? "bg-larc-ink text-white" : "text-larc-muted hover:bg-larc-alt hover:text-larc-ink"}`}
              data-testid={`admin-nav-${to.replace("/admin", "").replace("/", "") || "dashboard"}`}
            >
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-larc-border p-4 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-larc-muted hover:bg-larc-alt hover:text-larc-ink">
            <ExternalLink size={16} /> Mağazayı Gör
          </a>
          <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-larc-muted hover:bg-red-50 hover:text-red-600" data-testid="admin-logout">
            <LogOut size={16} /> Çıkış Yap
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <div className="px-8 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
